import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AppProvider } from './lib/app-context';
import './styles.css';
import './liquid.css';
import './premium-v32.css';
import './motion-v321.css';

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js?v=3.2.3-license-diagnostic', { updateViaCache: 'none' }).then((registration) => registration.update()).catch(() => undefined));
}

createRoot(document.getElementById('root')!).render(<React.StrictMode><AppProvider><App/></AppProvider></React.StrictMode>);
